<div class="navbar-container">
  <a routerLink="/attachments-list-builder" routerLinkActive="active" title="attachments-list-builder">
    Attachments Group Builder </a
  >&nbsp;&nbsp;
  <a routerLink="/attachments-group-options" routerLinkActive="active" title="attachments-group-options">
    Attachments Group Options </a
  >&nbsp;&nbsp;
  <a routerLink="/send-attachments-group" routerLinkActive="active" title="send-attachments-group">
    Send Attachments Group </a
  >&nbsp;&nbsp;
  <a
    routerLink="/attachments-group-invite-result"
    routerLinkActive="active"
    title="attachments-group-invite-result"
  >
    Attachments Group Invite Result </a
  >&nbsp;&nbsp;
</div>
